import { Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface ParagraphHintProps {
  paragraph: string;
  /** raw legal note text */
  text: string;
  children?: ReactNode;
}

/**
 * Tooltip helper for legal references (e.g. § 32 HKJGB).
 * Renders an info icon with the paragraph reference; the tooltip shows the
 * full legal text. Children, if present, become the trigger.
 */
export function ParagraphHint({ paragraph, text, children }: ParagraphHintProps) {
  const label = `${paragraph}: ${text}`;
  return (
    <Tooltip label={label} multiline w={320} withArrow>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
        {children}
        <IconInfoCircle size={14} aria-label={paragraph} />
      </span>
    </Tooltip>
  );
}
